import React from 'react';
import * as specialLinkStyles from '../../../styles/admissions/admissions.module.scss';
import * as styleLink from '../../../styles/communs/polylink.module.scss';
import { PropTypes } from 'prop-types';
import IconContainer from '../IconContainer';
import PolyLink from '../PolyLink';
import clsx from 'clsx';

const SpecialLink = ({
  subtitle,
  title,
  icon,
  link,
  disable,
  arrowDisable,
  color,
  textTransform,
  isRelatedContent = false,
  window = false,
  noIcon
}) => {
  const style = {};
  style.fontWeight = 600;
  if (color) {
    style.color = color;
  }
  if (textTransform === 'none') {
    style.textTransform = 'none';
  }

  const content = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: 'inherit',
      }}
    >
      <div>
        <p
          className={clsx({
            [styleLink.withoutIcon]: noIcon,
            [specialLinkStyles.relatedContentTitle]: isRelatedContent,
            [specialLinkStyles.title]: !isRelatedContent
          })}
          style={style}
        >
          {title}
        </p>
        <span
          className={isRelatedContent ?
            specialLinkStyles.relatedContentTitle : specialLinkStyles.title}
          style={style}
        >
          {subtitle}
        </span>
      </div>
      {!arrowDisable && (
        <div>
          <IconContainer
            color="BLACK"
            icon={'ARROW_RIGHT_NORMAL'}
            size={20}
            style={{'paddingTop': '3px'}}
            tabIndex={-1}
          />
        </div>
      )}
    </div>
  );

  return (
    <div className={specialLinkStyles.specialLinkContent}>
      <div style={{ marginRight: 15 }}>{icon}</div>
      {disable ? (
        <div style={{ width: '100%' }}>{content}</div>
      ) : (
        <PolyLink
          ariaLabel={title}
          className={specialLinkStyles.link}
          rel="noreferrer"
          target={window ? '_blank' : ''}
          url={link}
        >
          {content}
        </PolyLink>
      )}
    </div>
  );
};

SpecialLink.propTypes = {
  arrowDisable: PropTypes.bool,
  color: PropTypes.string,
  disable: PropTypes.bool,
  icon: PropTypes.object,
  isRelatedContent: PropTypes.bool,
  link: PropTypes.string,
  lowcase: PropTypes.bool,
  noIcon: PropTypes.bool,
  subtitle: PropTypes.string,
  textTransform: PropTypes.oneOf(['none', 'uppercase', 'lowercase', 'capitalize']),
  title: PropTypes.string.isRequired,
  window: PropTypes.bool,
};

export default SpecialLink;
